import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import { AuthSpinner } from '../authentication/AuthSpinner';
import { useAuthState } from '../authentication/context';
import Home from '../ConferencePages/Home';
import ConferenceList from '../ConferencePages/conferenceInfo/ConferenceList';
import VenueList from '../VenueVSBuildPages/VenueList';
import Error from '../ConferencePages/Error';
import { isDevDesk } from '../ConferencePages/conferenceInfo/utils';
import GroupList from '../GroupPages/GroupList';
import GroupDetail from '../GroupPages/GroupDetail';
import ActivePackagesList from '../ActivePackagesPages/ActivePackagesList';

export default function AppRouter() {
  const { isAuthenticated } = useAuthState();

  if (isAuthenticated || isDevDesk()) {
    return (
      <Switch>
        <Route exact path='/' component={Home} />
        <Route path='/conferences' component={ConferenceList} />
        <Route path='/groups/view-:id' component={GroupDetail} />
        <Route path='/groups' component={GroupList} />
        <Route path='/venuevsbuild' component={VenueList} />
        <Route path='/active-packages' component={ActivePackagesList} />
        <Route path='/error' component={Error} />
        <Route render={() => <Error />} />
      </Switch>
    );
  } else {
    return <AuthSpinner />;
  }
}
